import { Controller } from "@hotwired/stimulus"

// Multi-select dropdown widget. Replaces app/javascript/src/multiselect.js with
// a proper Stimulus controller — Turbo-friendly lifecycle, no manual init.
//
// Markup (see app/views/inc/_multiselect.html.erb):
//   <div data-controller="multiselect"
//        data-multiselect-placeholder-value="..."
//        data-action="click@window->multiselect#closeIfOutside
//                     keydown@window->multiselect#closeOnEscape">
//     <div data-multiselect-target="toggle"
//          data-action="click->multiselect#toggle
//                       keydown->multiselect#toggleByKey">
//       <span data-multiselect-target="label">…</span>
//     </div>
//     <div data-multiselect-target="panel"
//          data-action="change->multiselect#change">
//       <label><input type="checkbox" name="..."> …</label>
//       …
//     </div>
//   </div>
export default class extends Controller {
  static targets = ["toggle", "panel", "label"]
  static values  = { placeholder: { type: String, default: "" } }

  toggle(event) {
    event.preventDefault()
    this.setOpen(!this.element.classList.contains("open"))
  }

  toggleByKey(event) {
    if (event.key !== "Enter" && event.key !== " ") return
    event.preventDefault()
    this.toggle(event)
  }

  change(event) {
    if (!event.target.matches('input[type="checkbox"]')) return
    this.updateLabel()
  }

  closeIfOutside(event) {
    if (this.element.contains(event.target)) return
    this.setOpen(false)
  }

  closeOnEscape(event) {
    if (event.key !== "Escape") return
    this.setOpen(false)
  }

  // ---

  setOpen(open) {
    this.element.classList.toggle("open", open)
    this.toggleTarget.classList.toggle("active", open)
    this.toggleTarget.setAttribute("aria-expanded", open ? "true" : "false")
  }

  updateLabel() {
    const checked = this.panelTarget.querySelectorAll('input[type="checkbox"]:checked')
    const labels = Array.from(checked).map((cb) => {
      const text = cb.closest(".b-form__multiselect-option")?.querySelector(".b-form__checkboxlabel")
      return (text ? text.textContent : cb.value).trim()
    })
    this.labelTarget.textContent = labels.length ? labels.join(", ") : this.placeholderValue
  }
}
